export default "__VITE_ASSET__0df51d37__"